import { Component, OnDestroy, OnInit, HostListener, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';


import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Constants } from '../../constants';
import { NavLinks } from '../../nav-links';
import { LoginComponent } from '../login/login.component';

import { CommercialService, UserService } from '@core/services';
import { Commercial, User } from '@shared/models';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit, OnDestroy {

    @ViewChild(LoginComponent) childForm: LoginComponent

    public navLinks: any;
    public maintenanceMode: boolean;
    public customerServiceLinks: any;
    public isNavigationVisible = false;
    public isCollapsed = true;
    public isLoggedIn = false;
    public user: User;
    private commercial: Commercial;
    private currentUrl: string;
    logInSubscription: Subscription;
    userSubscription: Subscription;
    commercialSubscription: Subscription;
    routerSubscription: Subscription;

    constructor(private _userService: UserService, private _commercialService: CommercialService, private _router: Router, private route: ActivatedRoute) {
    }

    ngOnInit() {

        this.navLinks = NavLinks.NAV_LINKS;
        this.maintenanceMode = Constants.MAINTENANCE_MODE;
        this.customerServiceLinks = NavLinks.CUSTOMER_SERVICE_LINKS;

        this.routerSubscription = this._router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                console.log(event);

                // toggles navigation off for account setup process. (temporary fix)
                this.toggleNavigation(event);
                this.currentUrl = event.urlAfterRedirects;
            }
        });
        this.isCollapsed = true;
        this.logInSubscription = this._userService.loggedInChange$.subscribe(
            LoggedIn => {
                this.isLoggedIn = LoggedIn;
            }
        );

        this.userSubscription = this._userService.getUser().subscribe(
            user => {
                this.user = user;
            }
        );

        this.commercialSubscription = this._commercialService.getCommercialValue().subscribe(
            commercialVal => {
                this.commercial = commercialVal;
            }
        )
    }

    ngOnDestroy() {
        this.logInSubscription.unsubscribe();
        this.userSubscription.unsubscribe();
        this.commercialSubscription.unsubscribe();
        this.routerSubscription.unsubscribe();
    }

    logout() {
        // Get rid of token if the user explicitly logs out
        if(!localStorage.getItem('isCustomerService008c084!1')){
            localStorage.clear();
            sessionStorage.clear();
        } else {
            localStorage.clear();
            sessionStorage.clear();
            if(!localStorage.getItem('isCustomerService008c084!1')){
                localStorage.setItem('isCustomerService008c084!1', 'true')
            }
        
        }

        this.isCollapsed = true;
        this._userService.changeLogInStatus(false);
        this._router.navigate([Constants.NEXPRESS_HOME_PAGE]);
        this._userService.changeUser(new User('', '', '', '', 0, [], false, false, ''));

    }

    collapse() {
        this.isCollapsed = true;
    }

    toggleCollapse(evnt) {
        evnt.stopPropagation();
        this.isCollapsed = !this.isCollapsed;

    }

    // Temporary fix for hiding navigation on the account setup process.
    toggleNavigation(evnt) {
        const url = evnt.url;
        if(url === '/accountsetup' || url === '/addcreditcard') {
            this.isNavigationVisible = false;
        } else {
            this.isNavigationVisible = true;
        }
    }

    redirect(url: string) {
        this.collapse();
        this._router.navigate([url]);
    }

    hasProperty(obj: object, property: string) {
      return obj.hasOwnProperty(property);
    }

    // Uses ViewChild to set focus on email input when dropdown
    focusEmailInput() {
      setTimeout(() => {
        let previous = this.childForm.user.controls.email.value;
        if(!previous) this.childForm.user.reset();
        this.childForm.emailInput.nativeElement.focus();
      }, 0);
    }

    // Not sure what this was supposed to do, but it gives errors now.
    // @HostListener("document:click", ["$event"]) closeNav(event: Event) {
    //     if (event.srcElement.closest("#mainNavBar") === null) {
    //         this.isCollapsed = true;
    //     }
    // }

}



// WEBPACK FOOTER //
// C:/Users/EricChanney/Apps/nexpress-angular-site/src/app/component/header/header.component.ts